import styled from "styled-components";

const FullScreenLayout = styled.div`
  width: 100vw;
  height: 100vh;
  background-image: url(${(props) => props.background});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export default FullScreenLayout;
